import permission from './permission'
import functionIndex from './functionIndex'

// 自定义指令
const directives = {
  permission
}

export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key])
    })
  }
}

export {
  functionIndex
}
